import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIntersectionObserver from 'UIComponents/observer/UIIntersectionObserver';
import CollectionRouter from './CollectionRouter';
import ThemeResultsSectionDataContainer from '../../../components/storefront/results/ThemeResultsSectionDataContainer';
import { toSearchQuery } from '../../../utils/themeQuery';
import * as ThemeQueryField from '../../../constants/ThemeQueryField';
const MAX_HOME_COLLECTION_COUNT = 3;

const CollectionSection = ({
  className,
  collection,
  collectionType,
  linkTo,
  trackInteraction
}) => {
  const trackCollectionInteraction = useCallback((action, properties = {}) => {
    trackInteraction(action, Object.assign({}, properties, {
      section: `collection::${collection.id}::${collectionType}`,
      type: 'theme'
    }));
  }, [trackInteraction, collection.id, collectionType]);
  const searchQuery = toSearchQuery(collection.query.set(ThemeQueryField.LIMIT, MAX_HOME_COLLECTION_COUNT));
  return /*#__PURE__*/_jsx(UIIntersectionObserver, {
    onIntersectionChange: ({
      entries,
      observer
    }) => {
      if (entries[0].isIntersecting) {
        observer.disconnect();
      }
    },
    renderContent: isIntersecting => {
      if (isIntersecting) {
        return /*#__PURE__*/_jsx(ThemeResultsSectionDataContainer, {
          className: className,
          maxColumns: MAX_HOME_COLLECTION_COUNT,
          subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `marketplace-assets-ui.collections.collection_${collection.id}.subtitle`
          }),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `marketplace-assets-ui.collections.collection_${collection.id}.title`
          }),
          titleControls: /*#__PURE__*/_jsx(CollectionRouter, {
            linkTo: linkTo,
            linkText: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.storefront.home.exploreCollection",
              options: {
                title: collection.title
              }
            }),
            trackInteraction: trackInteraction
          }),
          trackInteraction: trackCollectionInteraction,
          searchQuery: searchQuery
        });
      }

      return /*#__PURE__*/_jsx("div", {});
    }
  });
};

export default CollectionSection;